import { render, staticRenderFns } from "./NextBtnWhite.vue?vue&type=template&id=0c5dce30"
import script from "./NextBtnWhite.vue?vue&type=script&lang=js"
export * from "./NextBtnWhite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports